import * as React from "react"
import { useTranslation } from "react-i18next"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"
const labelVariants = cva(
"text-sm font-medium leading-snug text-foreground peer-disabled:cursor-not-allowed peer-disabled:text-muted-foreground")

const Label = React.forwardRef<
 React.ElementRef<typeof LabelPrimitive.Root>,
 React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
 VariantProps<typeof labelVariants> & {
 required?: boolean
 }
>(({ className, children, required, ...props }, ref) => {
 const { t } = useTranslation()
 return (
 <LabelPrimitive.Root
 ref={ref}
 className={cn(labelVariants(), className)}
 {...props}
 >
 {children}
 {required && (
 <>
 <span className="text-destructive ms-1" aria-hidden="true">*</span>
 <span className="sr-only">{t('ui.required')}</span>
 </>
 )}
 </LabelPrimitive.Root>
 )
})
Label.displayName = LabelPrimitive.Root.displayName

export { Label }
